import { render } from "./home-sec5.vue?vue&type=template&id=a678b84a&scoped=true"
import script from "./home-sec5.vue?vue&type=script&lang=js"
export * from "./home-sec5.vue?vue&type=script&lang=js"

import "./home-sec5.vue?vue&type=style&index=0&id=a678b84a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a678b84a"]])

export default __exports__